import { Global } from '@emotion/react'

export const Fonts = () => (
  <Global
    styles={`
      @font-face {
        font-family: 'Euclid Square';
        src: url(/fonts/EuclidSquare/EuclidSquare-Light.woff) format('truetype');
        font-weight: 300;
        font-style: normal;
      }
      @font-face {
        font-family: 'Euclid Square';
        src: url(/fonts/EuclidSquare/EuclidSquare-LightItalic.woff) format('truetype');
        font-weight: 300;
        font-style: italic;
      }
      @font-face {
        font-family: 'Euclid Square';
        src: url(/fonts/EuclidSquare/EuclidSquare-Regular.woff) format('truetype');
        font-weight: 400;
        font-style: normal;
      }
      @font-face {
        font-family: 'Euclid Square';
        src: url(/fonts/EuclidSquare/EuclidSquare-RegularItalic.woff) format('truetype');
        font-weight: 400;
        font-style: italic;
      }
      @font-face {
        font-family: 'Euclid Square';
        src: url(/fonts/EuclidSquare/EuclidSquare-Medium.woff) format('truetype');
        font-weight: 500;
        font-style: normal;
      }
      @font-face {
        font-family: 'Euclid Square';
        src: url(/fonts/EuclidSquare/EuclidSquare-MediumItalic.woff) format('truetype');
        font-weight: 500;
        font-style: italic;
      }
      @font-face {
        font-family: 'Euclid Square';
        src: url(/fonts/EuclidSquare/EuclidSquare-Semibold.woff) format('truetype');
        font-weight: 600;
        font-style: normal;
      }
      @font-face {
        font-family: 'Euclid Square';
        src: url(/fonts/EuclidSquare/EuclidSquare-SemiboldItalic.woff) format('truetype');
        font-weight: 600;
        font-style: italic;
      }
      @font-face {
        font-family: 'Euclid Square';
        src: url(/fonts/EuclidSquare/EuclidSquare-Bold.woff) format('truetype');
        font-weight: 700;
        font-style: normal;
      }
      @font-face {
        font-family: 'Euclid Square';
        src: url(/fonts/EuclidSquare/EuclidSquare-BoldItalic.woff) format('truetype');
        font-weight: 700;
        font-style: italic;
      }
      @font-face {
        font-family: 'Soehne';
        src: url(/fonts/Sohne/soehne-buch.woff2) format('woff2');
        font-weight: 400;
        font-style: normal;
      }
      @font-face {
        font-family: 'Soehne';
        src: url(/fonts/Sohne/soehne-buch-kursiv.woff2) format('woff2');
        font-weight: 400;
        font-style: italic;
      }
      @font-face {
        font-family: 'Soehne';
        src: url(/fonts/Sohne/soehne-kraftig.woff2) format('woff2');
        font-weight: 700;
        font-style: normal;
      }
      @font-face {
        font-family: 'Soehne';
        src: url(/fonts/Sohne/soehne-kraftig-kursiv.woff2) format('woff2');
        font-weight: 700;
        font-style: italic;
      }
      @font-face {
        font-family: 'Soehne Breit';
        src: url(/fonts/Sohne/soehne-breit-kraftig.woff2) format('woff2');
        font-weight: 700;
        font-style: normal;
      }
      @font-face {
        font-family: 'Soehne Mono';
        src: url(/fonts/Sohne/soehne-mono-buch.woff2) format('woff2');
        font-weight: 400;
        font-style: normal;
      }
    `}
  />
)
